import { useSuspenseQuery } from "@tanstack/react-query";
import { orpc } from "@/orpc/client";
import { PartnerActivityChart } from "./PartnerActivityChart";
import { PartnerAppsTable } from "./PartnerAppsTable";
import { PartnerStatisticsCards } from "./PartnerStatisticsCards";

interface PartnerAnalyticsProps {
	partnerId: string;
}

export function PartnerAnalytics({ partnerId }: PartnerAnalyticsProps) {
	// Fetch statistics
	const { data: statistics } = useSuspenseQuery(
		orpc.partners.statistics.queryOptions({ input: { id: partnerId } }),
	);

	return (
		<div className="space-y-6 mt-6">
			<PartnerStatisticsCards statistics={statistics} />
			<PartnerActivityChart partnerId={partnerId} />
			<PartnerAppsTable partnerId={partnerId} />
		</div>
	);
}
